import { Component, Input, OnInit } from '@angular/core'
import { IconNamesEnum } from 'ngx-bootstrap-icons'
import { ArticleEmbedCommon } from 'src/app/shared/components/article-embed/article-embed-common'
import { Dictionary } from 'src/app/shared/components/filtering-search-component-base/filtering-search-types'
import { AsyncPipe } from '@angular/common'
import { CapitalStructureComponent } from '../../../shared/components/capital-structure/capital-structure.component'

@Component({
    selector: 'capstructure-embed',
    templateUrl: './capstructure-embed.component.html',
    styleUrls: ['./capstructure-embed.component.scss'],
    imports: [CapitalStructureComponent, AsyncPipe]
})
export class CapstructureEmbedComponent extends ArticleEmbedCommon implements OnInit {

  @Input() expandAll = false

  public isExpanded: Dictionary<boolean> = {}
  public iconNames = IconNamesEnum

  constructor() {
    super()
    this.contentSet = 'situations/capital-structure'
  }
}